/**
 * ChildProgress - one child's progress chart, reached from the Dashboard.
 *
 * A thin page: it resolves the child (so the heading can use their name and so
 * a bad id fails here rather than inside the chart) and hands the id to
 * ProgressChart. Ownership is enforced on the server - GET /chart returns 404
 * for a child the signed-in user does not own - and is not re-checked here,
 * because a second copy of an authorisation rule is a way to have two.
 */

import { useEffect, useState } from 'react';
import { useParams, Link } from 'react-router-dom';
import SEO from '../components/SEO';
import ProgressChart from '../components/chart/ProgressChart';
import { childrenApi } from '../utils/api';

export default function ChildProgress() {
  const { childId } = useParams();
  const [child, setChild] = useState(null);
  const [error, setError] = useState(null);

  useEffect(() => {
    let live = true;
    childrenApi.get(childId)
      .then((data) => { if (live) setChild(data.child || data); })
      .catch((e) => { if (live) setError(e.message || 'Could not find that child'); });
    return () => { live = false; };
  }, [childId]);

  const name = child ? child.name : '';

  return (
    <div className="min-h-screen bg-[#f7f9fc]">
      <SEO title={name ? `${name}'s progress` : 'Progress'} noIndex />

      <div className="max-w-5xl mx-auto px-4 pt-6 pb-2">
        <Link to="/dashboard" className="text-sm text-gray-500 hover:text-gray-700">
          ← Back to dashboard
        </Link>
        <h1 className="font-display text-2xl font-bold text-gray-900 mt-2">
          {name ? `${name}'s progress` : 'Progress'}
        </h1>
        <p className="text-sm text-gray-500 mt-1">
          Every skill the games listen for, and how each one is going.
        </p>
      </div>

      <div className="max-w-5xl mx-auto px-4">
        {error
          ? <div className="pc-state">{error}</div>
          : <ProgressChart childId={childId} childName={name} />}
      </div>
    </div>
  );
}
